import React, { Component } from 'react';
import Loading from '../../Components/Loading.js';
import { getHomepageInfo } from '../../Api/UserActions.js';
import { getTranslation } from '../../Utilities/GetTranslation.js';

declare var globalSns;

class Home extends Component {
    constructor(props) {
        super(props);

        this.state = {};

        //this.editApplication = this.editApplication.bind(this);
    }

    componentWillMount() {
        this.loadData();
    }

    loadData() {
        getHomepageInfo((data) => {
            this.setState({
                homepageInfo: data
            });
        });
    }

    render() {
        if (this.state.homepageInfo == null) {
            return (
                <Loading/>
            );
        }

        var countApplications = this.state.homepageInfo.applications;
        var countAttachments = this.state.homepageInfo.attachments;
        var countMails = this.state.homepageInfo.mails;
        var isCvActive = this.state.homepageInfo.isCvActive;

        return (
            <div className="registration">
                <div className="tiles text-center">
                    <a href={"/" + globalSns.cultureAlias + "/onlinecv"}>
                        <div className="icon"><i className="fa fa-id-card-o" aria-hidden="true"></i></div>
                        <div className="title">{globalSns.onlineCvName}</div>
                        <div className="text"></div>
                    </a>  
                    <a href={"/" + globalSns.cultureAlias + "/applications"}>
                        <div className="icon"><i className="fa fa-briefcase" aria-hidden="true"></i></div>
                        <div className="title">{globalSns.applicationsName}</div>
                        <div className="text">
                        {
                            (countApplications > 0) ?
                                countApplications + " " + getTranslation("sns.webparts.home.applications") : ""
                        }
                        </div>
                    </a>
                    <a href={"/" + globalSns.cultureAlias + "/attachments"}>
                        <div className="icon"><i className="fa fa-paperclip" aria-hidden="true"></i></div>
                        <div className="title">{globalSns.attachmentsName}</div>
                        <div className="text">
                        {
                            (countAttachments > 0) ?
                                countAttachments + " " + getTranslation("sns.webparts.home.attachments") : ""
                        }
                        </div>
                    </a> 
                    <a href={"/" + globalSns.cultureAlias + "/mailbox"}>
                        <div className="icon"><i className="fa fa-envelope-o" aria-hidden="true"></i></div>
                        <div className="title">{globalSns.mailboxName}</div>
                        <div className="text">
                        {
                            (countMails > 0) ?
                                countMails + " " + getTranslation("sns.webparts.home.mails") : ""
                        }
                        </div>
                    </a>
                    <a href={"/" + globalSns.cultureAlias + "/changepassword"}>
                        <div className="icon"><i className="fa fa-key" aria-hidden="true"></i></div>
                        <div className="title">{globalSns.changePasswordName}</div>
                        <div className="text"></div>
                    </a>
                    <a href={"/" + globalSns.cultureAlias + "/personalia"}>
                        <div className="icon"><i className="fa fa-user" aria-hidden="true"></i></div>
                        <div className="title">{globalSns.personaliaName}</div>
                        <div className="text"></div>
                    </a>                    
                    <a href={"/" + globalSns.cultureAlias + "/settings"}>
                        <div className="icon"><i className="fa fa-cog" aria-hidden="true"></i></div>
                        <div className="title">{globalSns.settingsName}</div>
                        <div className="text">
                        {
                            (isCvActive) ? getTranslation("sns.webparts.home.cvactive") : getTranslation("sns.webparts.home.cvinactive")
                        }
                        </div>
                    </a>
                </div>
            </div>
        );  
    }
}

export default Home;


// WEBPACK FOOTER //
// ./src/Components/Pages/Home.js